import React from 'react'

const InvoiceError: React.FC = () => {
  return (
    <div className="text-base text-gray-700 mt-2 text-center w-72">
      <span className="text-sm font-normal italic">
        Unable to generate invoice at this time. Please try again later.
      </span>
    </div>
  )
}

export default InvoiceError
